// antd specific style sheet that will be injected
// this unfortunately requires a lot of !importants, but, for now it's working reasonably enough.
import Color from 'color';
import theme from './theme';

export const antdStyle = `

  .ant-alert-message {
    font-size: 12px !important;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${theme.color.primary} !important;
    border-color: ${theme.color.primary} !important;
  }

  .ant-tag {
    border: 0px !important;
  }

  .ant-table-thead > tr > th {
    color: #efefef !important;
  }

  .ant-table-thead > tr > th .ant-table-column-sorter-up.on, .ant-table-thead > tr > th .ant-table-column-sorter-down.on {
    color: ${theme.color.primary} !important;
  }

  .ant-btn:hover, .ant-btn:focus {
    border-color: ${theme.color.primary} !important;
  }

  .ant-form-item-control-wrapper {
    flex: 1;
  }

  .ant-calendar-selected-date .ant-calendar-date {
    background: ${theme.color.primary} !important;
  }

  .ant-alert-description {
    font-size: 11px !important;
  }

  .ant-tabs-nav {
    padding-top: 31px !important;
  }


  .ant-input, ant-btn, ant-select, ant-table, ant-modal {
    font-family: ${theme.fontFamily} !important;
  }

  .ant-modal-header {
    background: ${theme.color.primary} !important;
  }

  .ant-table-column-sorter-down.on .anticon-caret-down {
    color: ${theme.color.primary} !important;
  }

  .ant-spin-dot i {
    background-color: ${theme.color.primary} !important;
  }

  .ant-menu-vertical .ant-menu-item:after, .ant-menu-vertical-left .ant-menu-item:after, .ant-menu-vertical-right .ant-menu-item:after, .ant-menu-inline .ant-menu-item:after {
    border-right: 3px solid ${theme.color.primary} !important;
  }

  .ant-btn-primary {
    color: #fff !important;
  }


  .ant-table-thead > tr.ant-table-row-hover > td, .ant-table-tbody > tr.ant-table-row-hover > td, .ant-table-thead > tr:hover > td, .ant-table-tbody > tr:hover > td {
    background: ${theme.color.primaryHover} !important;
    cursor: pointer;
  }

  .ant-pagination-item-active {
    border-color: ${theme.color.primary} !important
  }

  .ant-table {
    font-size: 12px !important
  }

  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: rgba(46, 204, 11, 0.23) !important;
  }

  .ant-steps-item-finish > .ant-steps-item-content > .ant-steps-item-title:after {
    background-color: rgba(46, 204, 11, 0.23) !important;
}

  .ant-switch-checked {
    background-color: ${theme.color.primary} !important;
}

  .ant-input, .ant-select-selection__rendered, .ant-textarea, .ant-select, .ant-option, .ant-textarea::placeholder, .ant-input::placeholder {
    font-family: ${theme.fontFamily} !important;
    font-size: 14px !important;
  }

  .trigger {
    font-size: 20px;
    line-height: 64px;
    cursor: pointer;
    transition: all .3s;
    margin: 0 4px;
  }
  

  .result {
    text-align: center;
    width: 72%;
    margin: 0 auto;
  
    .icon {
      font-size: 72px;
      line-height: 72px;
      margin-bottom: 24px;
  
      & > .success {
        color: ${theme.color.success} !important;
      }
  
      & > .error {
        color: ${theme.color.error};
      }
    }
  
    .title {
      font-size: 24px;
      color: @heading-color;
      font-weight: 500;
      line-height: 32px;
      margin-bottom: 16px;
    }
  
    .description {
      font-size: 14px;
      line-height: 22px;
      color: @text-color-secondary;
      margin-bottom: 24px;
    }
  
    .extra {
      background: #fafafa;
      padding: 24px 40px;
      border-radius: @border-radius-sm;
      text-align: left;
    }
  
    .actions {
      margin-top: 32px;
  
      button:not(:last-child) {
        margin-right: 8px;
      }
    }
  }
  

  .ant-modal-title, .ant-modal-close-x {
    color: #fff !important;
    text-align: center !important;
  }

  .ant-form {
    font-family: ${theme.fontFamily} !important;
  }

  .ant-modal-body {
    border-radius: 6px;
  }

  .ant-table-tbody {
    background: #fff !important;
  }

  .ant-table-thead > tr > th.ant-table-column-sort {
    background-color: #4f5d75 !important;
    color: #fffdf6 !important;
  }

  .ant-layout-content {
    background-color: #FBFCFC;
  }

  th {
    background-color: ${theme.color.navy1} !important;
    span{
      color: ${theme.color.normal} !important;
    }
  }

  .ant-btn-dashed:hover, .ant-btn-dashed:focus {
    color: #d7826a !important;
  }

  .ant-tabs {
    background: #fff !important;
  }

  .ant-tabs-content {
    background-color: ${theme.color.background} !important;
  }

  .ant-transfer-list {
    background: #fff !important;
  }

  .ant-select-dropdown-menu-item:hover {
    background-color: ${theme.color.primaryHover} !important;
  }

  .ant-select-focused .ant-select-selection, .ant-select-selection:focus, .ant-select-selection:active {
    border-color: ${theme.color.primaryHover} !important;
  }

  .ant-input:focus, ant-select-selection:focus, .ant-select-selection:hover, .ant-input:hover {
    border-color: ${theme.color.primaryHover} !important;
    box-shadow: 0 0 0 2px ${theme.color.primaryHover} !important;
  }

  .ant-radio-button-wrapper-checked:first-child {
    border-color: ${theme.color.primaryHover}!important;
    color: ${theme.color.primaryHover}!important;
    box-shadow: none !important;
  }

  .ant-fullcalendar-fullscreen .ant-fullcalendar-today .ant-fullcalendar-date {
    border-top-color: ${theme.color.primaryHover}!important;
  }
  

  .ant-layout-sider {
    background-color: ${theme.color.navy1} !important;
  
    .ant-menu-item {
      color: ${theme.color.normal} !important;
      margin-top: 10px !important;
      font-size: 15px !important;
      font-weight: 300 !important;
    }
    .ant-menu-inline {
      border-right: 0px !important;
    }
    .ant-menu-item-selected {
      background-color: ${theme.color.primaryHover} !important;
    }
  
    .ant-layout-sider-children div {
      background-color: ${theme.color.navy1} !important;
    }
  
    ul.ant-menu-root {
      background-color: ${theme.color.navy1} !important;
    }
  
    .sider-nav-icon {
      font-size: 15px;
      color: ${theme.color.normal};
    }
  
  }

  /********** TABS *********/

  .ant-tabs-bar {
    background-color: #fff !important;
  }

  .ant-tabs-nav .ant-tabs-tab-active {
    color: ${theme.color.primary} !important;
  }

  .ant-tabs-nav .ant-tabs-tab:hover {
    color: ${theme.color.primaryHover} !important;
  }

  .ant-steps-item-custom.ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {
    color: ${theme.color.primary} !important;
  }

  .ant-modal-content {
    border-radius: 5px;
  }

  .ant-btn-primary {
    background-color: ${theme.colorPrimary} !important;
    border-color: ${theme.colorPrimary} !important;
    color: #fff;
    font-family: ${theme.fontFamily} !important;
    font-weight: 700;
    transition-delay: 0s;
    transition-duration: 0.15s;
    transition-property: all;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 0.045em;
  }

  .ant-table-thead > tr > th {
    background-color: ${theme.colorPrimary};
    color: ${theme.color.normal};
  }
  
  .ant-tabs-vertical.ant-tabs-left > .ant-tabs-bar .ant-tabs-tab {
    height: 50px;
  }
  
  .ant-tabs-content {
    min-height: 1000px;
  }
  
  // CHECKBOXES
  // ========================================
  .ant-checkbox-inner {
    height: 18px;
    width: 18px;
  }
  
  .ant-checkbox-checked .ant-checkbox-inner:after {
    width: 6px !important;
    height: 10px !important;
    left: 5px !important;
    top: 2px !important;
  }
  
  
  .ant-btn-primary:hover {
    background-color: #d7826a !important;
    border-color: #d7826a !important;

  }

  .ant-btn-primary {
    border: 0px  !important;
  }


  .ant-select-selection__rendered {
    font-size: 14px !important;
  }



.ant-layout-sider-collapsed {
  .headway-widget-wrapper {
      display: none;
  }
}



 /* input, textarea, .ant-select, .ant-select-selection, .ant-select-lg, .ant-input-number  {
    background: #e1e1e1 !important;
    border-color: #e1e1e1 !important;
    border-radius: 4px;
  }

  .ant-select-lg .ant-select {
    background: #e1e1e1 !important;
    border-color: #e1e1e1 !important;
    border-radius: 4px;
  } */
    
}

`;

export default antdStyle;



// WEBPACK FOOTER //
// ./src/lib/theme/antdStyle.js